import React from 'react';
import { CustomMap } from './CustomMap';

export const CoverageMap = () => {
  return (
    <section id="cobertura" className="py-16 bg-white scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-lufga-semibold text-salbox-primary mb-6 uppercase">
            Zona de Cobertura
          </h2>
          <p className="text-lg font-lufga text-salbox-neutral-600 max-w-2xl mx-auto">
            Entregamos en las principales zonas de la ciudad. Verifica si tu ubicación está dentro de nuestro alcance.
          </p>
        </div>

        <div className="bg-salbox-neutral-100 rounded-xl p-8 max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Columna de zonas */}
            <div className="space-y-4">
              <h3 className="text-lg font-lufga-semibold text-salbox-primary mb-4">Zonas de Cobertura</h3>
              <div className="space-y-3">
                <div className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border border-salbox-primary/10">
                  <h4 className="font-lufga-semibold text-salbox-primary mb-2">Zona Automotriz</h4>
                  <p className="text-sm text-salbox-neutral-600 font-lufga">Agencias BMW, MINI, Nissan, Mazda, Volkswagen, Porsche y más</p>
                </div>
                <div className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border border-salbox-primary/10">
                  <h4 className="font-lufga-semibold text-salbox-primary mb-2">Plazas Comerciales</h4>
                  <p className="text-sm text-salbox-neutral-600 font-lufga">Antea, WTC, Plaza Kova, Platinum Business Center</p>
                </div>
                <div className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border border-salbox-primary/10">
                  <h4 className="font-lufga-semibold text-salbox-primary mb-2">Empresas & Oficinas</h4>
                  <p className="text-sm text-salbox-neutral-600 font-lufga">DHL, Autozone, Media Master, TecnoCont y oficinas corporativas</p>
                </div>
              </div>
            </div>

            {/* Mapa */}
            <div className="lg:col-span-3">
              <div className="aspect-video bg-white rounded-lg shadow-lg overflow-hidden">
                <CustomMap className="w-full h-full" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};